module.exports = __webpack_public_path__ + "static/media/FELV_POSITIVE.4069148b.svg";